module.exports = __webpack_public_path__ + "static/media/achievement-colleagues-video-hangout.8796da42.svg";